import React, {useDebugValue} from 'react';

import classNames from 'classnames';

import {ButtonIcon as ButtonIconDefault, ButtonIconPrimary} from '@homeaway/react-buttons';

// ButtonIconDefault.whyDidYouRender = true;
// ButtonIconPrimary.whyDidYouRender = true;

import {
    useSearchFormContext,
    useTrackingContext
} from '../../../hooks';

import {
    hasCheckAvailabilitySubmitActionType,
    showSubmitPrimaryAction,
    triggerSubmitSummaryClickEdapEvent
} from '../../../utils';

import {SearchIcon} from '../../SearchIcon';

const classNamespace = 'search-form';
const fieldClassName = `${classNamespace}__field`;
const buttonFieldClassName = `${classNamespace}__button-field`;
const summaryFieldClassName = `${classNamespace}__summary-field`;
const summaryButtonFieldClassName = `${classNamespace}__summary-button-field`;
const submitSummaryButtonFieldClassName = `${classNamespace}__submit-summary-button-field`;

function useComponent() {
    const {
        edapOptions,
        formSettings: {
            hasLoaded,
            isSubmitting
        },
        submitEvents: {
            onClick: onSubmitClick
        },
        submitOptions,
        submitOptions: {
            iconName
        },
        submitTranslations: {
            checkAvailabilityLabelText,
            searchLabelText
        },
        submitSummaryEvents: {
            onClick: onSubmitSummaryClick
        }
    } = useSearchFormContext();

    const trackingContext = useTrackingContext();

    const className = classNames(fieldClassName, buttonFieldClassName, summaryFieldClassName, summaryButtonFieldClassName, submitSummaryButtonFieldClassName);

    const ButtonIcon = (
        showSubmitPrimaryAction(submitOptions)
            ? ButtonIconPrimary
            : ButtonIconDefault
    );

    const type = 'submit';

    const labelIcon = (
        <SearchIcon iconName={iconName}/>
    );

    const labelText = (
        hasCheckAvailabilitySubmitActionType(submitOptions)
            ? checkAvailabilityLabelText
            : searchLabelText
    );

    const label = (
        <>
            {labelIcon}
            <span className="sr-only">{labelText}</span>
        </>
    );

    const srOnlyLabel = false;

    const disabled = !hasLoaded || isSubmitting;
    const loading = hasLoaded && isSubmitting;

    function handleClick(...args) {
        triggerSubmitSummaryClickEdapEvent(trackingContext, edapOptions);

        onSubmitClick(...args);
        onSubmitSummaryClick(...args);
    }

    const result = {
        className,
        ButtonIcon,
        type,
        label,
        srOnlyLabel,
        disabled,
        loading,
        onClick: handleClick
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
